import { TextField } from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function FinalStatsByAgent() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
      </div>
      <Report
        title="Final Stats By Agent Report"
        getUrl={() => "/Reports/Report_Final_Stats_By_Agent_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Book: book,
          Group: group,
          Distributor: distributor,
          AgentTo: agentTo,
          AgentFrom: agentFrom,
        })}
        getProcess={(data) =>
          data.map((item) => ({
            ...item,
            total: item.horseWL + item.casinoWL + item.sportsWL,
          }))
        }
        getTotals={(data) => ({
          agent: "Total",
          countPlayer: data.reduce((acc, item) => acc + item.countPlayer, 0),
          countOnlinePlayer: data.reduce(
            (acc, item) => acc + item.countOnlinePlayer,
            0
          ),
          horseWL: data.reduce((acc, item) => acc + item.horseWL, 0),
          casinoWL: data.reduce((acc, item) => acc + item.casinoWL, 0),
          sportsRisk: data.reduce((acc, item) => acc + item.sportsRisk, 0),
          sportsWin: data.reduce((acc, item) => acc + item.sportsWin, 0),
          sportsWL: data.reduce((acc, item) => acc + item.sportsWL, 0),
          total: data.reduce((acc, item) => acc + item.total, 0),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="agent">
          Agent
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="countPlayer">
          # Players
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="countOnlinePlayer">
          # Players By Phone
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="horseWL"
          dataFormat={decimalInvertedReportFormatter}
        >
          Horse W/L
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="casinoWL"
          dataFormat={decimalInvertedReportFormatter}
        >
          Casino W/L
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="sportsRisk"
          dataFormat={decimalInvertedReportFormatter}
        >
          Sports Risk
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="sportsWin"
          dataFormat={decimalInvertedReportFormatter}
        >
          Sports Win
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="sportsWL"
          dataFormat={decimalInvertedReportFormatter}
        >
          Sports W/L
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="total"
          dataFormat={decimalInvertedReportFormatter}
        >
          Total
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default FinalStatsByAgent;
